// 支付页接口
// eslint-disable-next-line import/no-cycle
import ajax from '@/utils/ajax';

const header = '/web';
// 查询用户是否绑定
export const reqWeChatBindQuery = (appId, code) => ajax(`${header}/v1/user/bind/wechat-bind?appId=${appId}&code=${code}`);
// 绑定手机号和微信
export const reqWeChatBind = (data) => ajax(`${header}/v1/user/bind/wechat-bind`, data, 'POST');
// 解绑手机号和微信
export const reqCancelWeChatBind = (data) => ajax(`${header}/v1/user/bind/wechat-bind/cancel`, data, 'POST');
// 获取微信公众号签名
export const reqPostWeChatSignature = (data) => ajax(`${header}/v1/common/wechat/mp/js-api-signature`, data, 'POST');
